import { useMemo } from 'react';
import { cx } from '@epam/uui-core';
import { FlexRow, FlexSpacer, IconButton, Panel, Text } from '@epam/promo';
import { ReactComponent as UnfoldedIcon } from '@epam/assets/icons/common/navigation-chevron-down-18.svg';
import { ReactComponent as FoldedIcon } from '@epam/assets/icons/common/navigation-chevron-up-18.svg';
import { ReactComponent as NavIcon } from '@epam/assets/icons/common/navigation-chevron-right-18.svg';

import { useTaskStore } from 'store/task';
import { getFormatedText } from 'hooks/helpers/common';
import { WithTooltip } from 'components/common/WithTooltip';
import { CardList } from '../CardList';
import { GroupItemProps } from './GroupItem.model';
import css from './GroupItem.module.scss';

const MAX_TITLE_LENGTH = 28;

export const GroupItem = ({
  groupName,
  groupId,
  active,
  setActive,
}: GroupItemProps) => {
  const { tasks, draft: draftTask } = useTaskStore((state) => state);

  const groupTasks = useMemo(
    () => tasks.filter((task) => task.taskGroupId === groupId),
    [tasks, groupId],
  );

  const isActiveTaskInside = groupId === draftTask.taskGroupId;
  const isActive = active === groupId;
  const isEmpty = !groupTasks.length;
  const closedIcon = isActiveTaskInside ? NavIcon : UnfoldedIcon;
  const isGroupNameTooLong = groupName.length > MAX_TITLE_LENGTH;

  const handleToggle = () => {
    if (isActive) {
      setActive('');
    } else if (groupTasks.length) {
      setActive(groupId);
    }
  };

  return (
    <Panel cx={css.item}>
      <WithTooltip condition={isGroupNameTooLong} text={groupName}>
        <FlexRow
          cx={{
            [css.header]: true,
            [css.header__active]: isActiveTaskInside,
          }}
          onClick={handleToggle}>
          <Text cx={css.header__title}>
            {getFormatedText(groupName, MAX_TITLE_LENGTH)}
          </Text>
          {!isEmpty && (
            <>
              <FlexSpacer />
              <IconButton
                cx={css.header__icon}
                icon={isActive ? FoldedIcon : closedIcon}
              />
            </>
          )}
        </FlexRow>
      </WithTooltip>
      {isActive && !isEmpty && (
        <div
          className={cx(
            css.list,
            isActiveTaskInside && css['list__active-group'],
          )}>
          <CardList items={groupTasks} />
        </div>
      )}
    </Panel>
  );
};
